import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import qs from 'qs'

import './SearchForm.css'

//material-ui
import { useTranslation } from 'react-i18next'
import { Box, FormControl, InputLabel, Input, FormHelperText, Tooltip, Typography, InputAdornment, IconButton } from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search';

const SearchForm = ({ history,  location }) => {
    const { t } = useTranslation()
    const [searchForm, setSearchForm] = useState({
        searchQuery: ''
    })

    const handleInputChange = e => {
        const { name, value } = e.target
        setSearchForm(prevState => ({...prevState, [name]: value}))
    }

    const handleSubmit = (e) => {
        e.preventDefault()
      history.push({
        pathname: '/search',
        state: {
          searchQuery: searchForm['searchQuery']
        }
      })
    }

    return (
      <form onSubmit={handleSubmit}>
          <FormControl>
            <InputLabel htmlFor="my-input">{t('search.form.label')}</InputLabel>
            <Input id="searchQuery" name="searchQuery" type="text" value={searchForm.searchQuery} placeholder={t('search.form.placeholder')} onChange={handleInputChange} autoComplete="off"
            
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleSubmit}
                  >
                    <SearchIcon/>
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>
        </form>
    )
}

SearchForm.propTypes = {
}

export default withRouter(SearchForm);
